import React from 'react';
import {Chip} from "@material-ui/core";

interface ChipComponentProps {
  editable?: boolean;
  item?: string | Array<string>;
  onDeleteCallback?: (value: string) => void;
  DeleteIcon?: React.ElementType;
}

 const ChipComponent=(props:ChipComponentProps)=> {
 const {editable, item, onDeleteCallback, DeleteIcon} =props

  // Normalize item to always be an array
  const items = React.useMemo(() => {
    if (!item) return [];
    return Array.isArray(item) ? item : [item];
  }, [item]);

  const GetDelatableChips = () => {
    return (
      <>
        {items.length > 0 && items.map((element: string, index: number) => {
          return  <Chip
          key={element+index}
          label={element}
          onDelete={()=>onDeleteCallback && onDeleteCallback(element)}
          deleteIcon={DeleteIcon ? <DeleteIcon /> : undefined}
        />
        })}
      </>
    );
  
  };
  const GetUnDelatableChips = () => {
    return (
      <>
        {items.length > 0 && items.map((element: string, index: number) => {
          return  <Chip label={element} key={element+index}/>
        })}
      </>
    );
    
  };

  return (
  <>
  {editable ? <GetDelatableChips /> :<GetUnDelatableChips />}
 
  </>
  );
}
export default ChipComponent